const ProductClassificationIcon = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="prod-clearance-class-grad" x1="-6.5" y1="18.5" x2="20" y2="4.016e-07" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--s247-icon-start, #EE5B33)"/>
        <stop offset="1" stopColor="var(--s247-icon-end, #AB2A86)"/>
      </linearGradient>
    </defs>
    <path d="M15.4658 7.29236e-07H0.533333C0.238222 7.29236e-07 0 0.233626 0 0.525001V2.625H16V0.525001C16 0.455983 15.9862 0.387643 15.9593 0.32389C15.9325 0.260137 15.8931 0.202222 15.8435 0.15346C15.7939 0.104698 15.735 0.0660447 15.6701 0.0397125C15.6053 0.0133803 15.5359 -0.0001143 15.4658 7.29236e-07ZM0.888889 12.775C0.888889 13.4488 1.448 14 2.13244 14H13.8658C14.5502 14 15.1102 13.4479 15.1102 12.775V3.5H0.888889V12.775ZM5.33333 5.25H10.6667V7H5.33333V5.25Z" fill="url(#prod-clearance-class-grad)"/>
  </svg>
);
import Section from 'Components/Section';
import { usePopup } from 'Hooks';
import { CONFIRM_SELECT_PRODUCT_POPUP } from 'Pages/C2cOrderPayment/constants';

import {
	C2cCategoryPackageTypeEnum,
	C2cOverPaymentTextEnum,
} from 'Pages/C2cOrderPayment/enums';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
	c2cOrderPaymentSelectors,
	C2cOverPaymentState,
	choosePackageTypeAction,
	setDeclarationPolicyAgreement,
} from 'Stores/c2c-order-payment';
import { grapSelectors } from 'Stores/grap';
import { GrapBlogsSlugEnums } from 'Stores/grap/enums';
import { layoutUtilitiesSliceSelectors } from 'Stores/layout-utilities';
import { LanguageTypeEnum } from 'Stores/layout-utilities/enums';
import { ProductTypeSwitch } from '..';
import { ButtonAddProduct } from '../c2cPickedUpProduct';
import GoodsInformation from '../GoodsInformation/GoodsInformation';
import './index.scss'

const ProductClearanceDeclaration = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const popup = usePopup();
	const { currentLanguage } = useSelector(layoutUtilitiesSliceSelectors.get);
	const { isGlobal } = useSelector(c2cOrderPaymentSelectors.get);

	const {
		packageTypeSelected,
		typeOrder,
		declarationPolicyAgreement,
	} = useSelector(c2cOrderPaymentSelectors.get) as C2cOverPaymentState;
	const { blogs } = useSelector(grapSelectors.get);


	const getDeclarationPolicyContent = () => {
		let fieldDes = '';
		switch (currentLanguage) {
			case LanguageTypeEnum.VietNam:
				fieldDes = 'descriptionVi';
				break;
			case LanguageTypeEnum.Korea:
				fieldDes = 'descriptionKo';
				break;
			case LanguageTypeEnum.English:
				fieldDes = 'descriptionEn';
				break;
		}
		const description = blogs
			?.find((blog: any) => blog?.slug === GrapBlogsSlugEnums.Rules)
			?.[fieldDes]?.toString();
		return description?.split('.');
	};


	const handleChangePackage = (actionType: C2cCategoryPackageTypeEnum) => {
		if (
			actionType === C2cCategoryPackageTypeEnum.Document &&
			!declarationPolicyAgreement?.acceptedDocumentRules &&
			isGlobal
		) {
			openDeclarationPolicyAgreementPopup(true);
			return;
		}
	};

	const handleAddProductDeclaration = () => {
		if (declarationPolicyAgreement?.acceptedParcelRules) {
			openPopupAddGoods();
			return;
		}
		openDeclarationPolicyAgreementPopup(false);
	};

	const openPopupAddGoods = () => {
		popup.onOpen(
			{
				title: 'c2c_goods_info_title',
				hideFooter: true,
				maxHeight: '90vh',
				height: 794,
				maxWidth: 1000
			},
			<GoodsInformation></GoodsInformation>
		);
	};

	const openDeclarationPolicyAgreementPopup = (isDocument: boolean) => {
		popup.onOpen(
			{
				...CONFIRM_SELECT_PRODUCT_POPUP,
				title: 'global_confirm_declared_info',
				hideBtnCancel: true,
				btnFullWidth: true,
				maxWidth: 450,
				okBtnLabel: 'global_accept_action',
				onSubmit: (isAccept: boolean) => {
					if (isAccept) {
						onAcceptRules(isDocument);
					}
				}
			},
			getDeclarationPolicyContent()
				?.filter((des: string) => des?.trim() !== '')
				?.map((des: string) => <p key={des}>{des}.</p>)
		);
	};

	const onAcceptRules = (isDocument: boolean) => {
		if (isDocument) {
			dispatch(
				setDeclarationPolicyAgreement({
					...declarationPolicyAgreement,
					acceptedDocumentRules: true
				})
			);
			dispatch(choosePackageTypeAction(C2cCategoryPackageTypeEnum.Document));
			return;
		}
		dispatch(
			setDeclarationPolicyAgreement({
				...declarationPolicyAgreement,
				acceptedParcelRules: true
			})
		);
		// navigate('/goods-info');
		openPopupAddGoods();
	};

	return (
		<Section
			title={t(C2cOverPaymentTextEnum.ProductClassification_Title)}
			icon={<ProductClassificationIcon />}
		>
			<div className="product-clearance-declaration">

				<ProductTypeSwitch
					typeOrder={typeOrder}
					packageTypeSelected={packageTypeSelected}
					handleChangePackage={handleChangePackage}
				></ProductTypeSwitch>

				{isGlobal &&
				packageTypeSelected === C2cCategoryPackageTypeEnum.Parcel && (
					<ButtonAddProduct
						onClick={handleAddProductDeclaration}
					></ButtonAddProduct>
				)}
			</div>


		</Section>
	);
};

export default ProductClearanceDeclaration;
